import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

import {t} from 'common/utils/translation-util';
import {BatteryStatusEnum} from 'common/proxies/enum-proxy';
import './index.scss';

const BATTERY_ICON = {
  [BatteryStatusEnum.GOOD.id]: 'fa-battery-full',
  [BatteryStatusEnum.MEDIUM.id]: 'fa-battery-half',
  [BatteryStatusEnum.LOW.id]: 'fa-battery-quarter',
};

const getBatteryStatus = (id) => {
  const status = Object.values(BatteryStatusEnum).find((bs) => bs.id === id);
  if (status) {
    return status.displayName;
  }
  return ' - ';
};

const getCssClass = (...args) =>
  `BuildingLocationDeviceInfo${args.length ? `--${args.join('--')}` : ''}`;

const BuildingLocationDeviceInfo = ({
  batteryLevel,
  batteryVoltage,
  deviceDataUrl,
  isUTC,
  lastPositionDate,
  lastStatusDate,
  name,
  onClose,
}) => {
  return (
    <div className={getCssClass()}>
      <div className={getCssClass('Header')}>
        {deviceDataUrl ? (
          <a
            className={getCssClass('Header', 'Title')}
            href={deviceDataUrl}
            rel={'noopener noreferrer'}
            target={'_blank'}>
            {name}
          </a>
        ) : (
          <div className={getCssClass('Header', 'Title')}>{name}</div>
        )}
        <div className={getCssClass('Header', 'CloseButton')} onClick={onClose}>
          <i className={'fa-times'} />
        </div>
      </div>
      {lastPositionDate ? (
        <div className={getCssClass('DetailRow')}>
          <div className={getCssClass('DetailRow', 'Label')}>
            {t('Last position date')}
          </div>
          <div className={getCssClass('DetailRow', 'Value')}>
            {isUTC
              ? moment.utc(lastPositionDate).fromNow()
              : moment(lastPositionDate).fromNow()}
          </div>
        </div>
      ) : null}
      {lastStatusDate ? (
        <div className={getCssClass('DetailRow')}>
          <div className={getCssClass('DetailRow', 'Label')}>
            {t('Last status date')}
          </div>
          <div className={getCssClass('DetailRow', 'Value')}>
            {isUTC
              ? moment.utc(lastStatusDate).fromNow()
              : moment(lastStatusDate).fromNow()}
          </div>
        </div>
      ) : null}
      {batteryLevel ? (
        <div className={getCssClass('DetailRow')}>
          <div className={getCssClass('DetailRow', 'Label')}>
            {t('Battery level')}
          </div>
          <div
            className={classNames(
              getCssClass('DetailRow', 'Value'),
              'BatteryLevel',
            )}>
            {BATTERY_ICON[batteryLevel] ? (
              <div className={'BatteryLevel--Icon'}>
                <i className={BATTERY_ICON[batteryLevel]} />
              </div>
            ) : null}
            <div className={'BatteryLevel--Value'}>
              {getBatteryStatus(batteryLevel)}
            </div>
            {batteryVoltage ? (
              <div className={'BatteryLevel--Voltage'}>
                {`(${batteryVoltage}V)`}
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};

BuildingLocationDeviceInfo.propTypes = {
  batteryLevel: PropTypes.string,
  batteryVoltage: PropTypes.number,
  deviceDataUrl: PropTypes.string,
  isUTC: PropTypes.bool,
  lastPositionDate: PropTypes.string,
  lastStatusDate: PropTypes.string,
  name: PropTypes.string,
  onClose: PropTypes.func,
};

BuildingLocationDeviceInfo.defaultProps = {
  deviceDataUrl: '',
  name: '',
  onClose: () => null,
};

export default BuildingLocationDeviceInfo;
